import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/2-walls-1.svg`,
          },
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/2-walls-2.svg`,
          },
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/2-walls-3.svg`,
          },
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/2-walls-4.svg`,
          },
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/2-walls-5.svg`,
          },
        },
      },
    },
  ],
];

export default components;
